<template>
    <i :class="classSummary"></i>
</template>


<script>
// Icon component

// trash
// plus
// pencil

export default {
  props: ['icon', 'text', 'icon_style'],
  data() {
    return {
      iconClass: `fa-${this.icon}`,
    }
  },
  computed: {
    classSummary() {
      let styleClass = 'fas';
      if (this.icon_style === 'regular' || this.icon_style === 'far') { styleClass = 'far' }
      return `${styleClass} ${this.iconClass}`
    }
  }
}
</script>

